import { fetchAPI, URL_API } from "api";

const ROTA = '/forms/beneficiarios';

class BeneficiarioAPI {
    // Cria um novo beneficiário vinculado a uma CIFA
    static async createBeneficiario(data: any) {
        const response = await fetchAPI(`${URL_API}${ROTA}`, 'POST', data);
        return response;
    }

}

export default BeneficiarioAPI;